import request from '@/utils/request';

export function videoGetOne(params) {
  return request({
    url: '/video/getOne',
    method: 'get',
    params,
  });
}

export function uploadRecord(data) {
  return request({
    url: '/page/uploadRecord',
    method: 'post',
    data,
  });
}

//提交作业
export function commitTips(data) {
  return request({
    url: '/page/commitTips',
    method: 'post',
    data,
  });
}
